import React from 'react';
import { ReactComponent as DeleteIcon } from '../../../_shared/assets/icons/delete.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { Modal } from '../Modal/Modal';
import { Typography } from '../Typography/Typography';
import { Button } from '../Button/Button';
import styles from './KpiDeleteModal.module.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function KpiDeleteModal({ isOpen, onClose, onConfirm }: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'small'}>
      <button className={styles.closeIcon} onClick={onClose}>
        <CloseIcon />
      </button>
      <div className={styles.kpiModal}>
        <div className={styles.head}>
          <Typography variant="h2" className={styles.title}>
            Удаление КПЭ
          </Typography>
        </div>

        <Typography variant="text" className={styles.description}>
          Текст подтверждения удаления
        </Typography>

        <div className={styles.actions}>
          <Button variant="secondary" size="small" onClick={onClose}>
            Отмена
          </Button>
          <Button variant="primary" size="small" onClick={onConfirm}>
            Удалить
            <DeleteIcon className={styles.deleteIcon} />
          </Button>
        </div>
      </div>
    </Modal>
  );
}
